const LANGUAGE_CODES = {
    DE: 'de'
};

export {
    LANGUAGE_CODES
};
